var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertsNotifications01 = function SvgAlertsNotifications01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 36.76,
    y1: 176.53,
    x2: 173.98,
    y2: 51.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#a80096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#a80096"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.02,153.45c-21.46-21.73-21.86-42.64-21.86-42.83v-28.42c-.04-24.84-16.61-46.63-40.55-53.3v-12.28C116.62,7.46,109.2.01,100.03,0c-9.17-.01-16.62,7.41-16.63,16.58,0,.02,0,.03,0,.05v12.27c-23.93,6.67-40.51,28.45-40.55,53.3v28.41c0,.21-.4,21.12-21.86,42.84-4.97,5.2-4.77,13.45.43,18.41,2.39,2.28,5.55,3.56,8.84,3.6h41.88c1.96,15.38,16.02,26.26,31.4,24.3,12.69-1.62,22.69-11.61,24.3-24.3h41.91c7.19-.08,12.96-5.98,12.87-13.18-.04-3.3-1.32-6.45-3.6-8.84h0ZM90.54,16.63c.06-5.23,4.34-9.42,9.57-9.36,5.14.06,9.3,4.21,9.36,9.36v10.8c-6.28-.85-12.65-.85-18.93,0v-10.8ZM99.99,192.86c-10.19-.02-18.89-7.35-20.64-17.39h41.27c-1.75,10.04-10.45,17.37-20.63,17.39h0ZM175.13,164.72c-.87,2.21-3.01,3.64-5.38,3.6,0,0-116.06.02-139.49,0-3.22-.03-5.82-2.66-5.79-5.88.01-1.48.58-2.9,1.6-3.97,23.65-23.95,23.92-46.89,23.92-47.85v-28.42c.13-26.83,21.99-48.47,48.81-48.33,1,0,1.99.04,2.98.11,26.62.03,48.2,21.61,48.23,48.23v28.42c0,.97.27,23.9,23.92,47.85,1.66,1.63,2.14,4.12,1.2,6.25h0Z"
  })));
};
export default SvgAlertsNotifications01;